// extracted by mini-css-extract-plugin
export default {"toggle":"style_toggle__8XAFO","disabled":"style_disabled__3c3vh","round":"style_round__BWd5g","active":"style_active__LtYCv","text":"style_text__rAMqP"};